export const routes = [
  {
    path: "/dashboard-territorios",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "./components/View"),
    name: "dashboard-territorios",
  },
];
